import { RootState } from 'types'
import { Action } from 'redux/actions'
import { FocusModeActions } from '../actions/focusMode'

export default function reduce(
  state: RootState['focusMode'] = { showFocusMode: false, focusModeDisabled: false, manual: false },
  action: Action,
): RootState['focusMode'] {
  switch (action.type) {
    case FocusModeActions.FOCUS_MODE_SET: {
      return {
        ...state,
        showFocusMode: action.payload.showFocusMode,
        manual: action.payload.showFocusMode && !!action.payload.manual,
      }
    }
    case FocusModeActions.FOCUS_MODE_ENABLED_SET: {
      return {
        ...state,
        focusModeDisabled: !action.payload.enableFocusMode,
      }
    }
    default:
      return state
  }
}
